"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwinkleStar = exports.TourPixel = exports.TourActionsContainer = exports.Title = exports.StyledLink = exports.StyledGIF = exports.StyledCloseIcon = exports.StyledArrowTour = exports.StyledArrowIcon = exports.StepCounter = exports.NextButton = exports.InnerLastStepContainer = exports.InnerContainer = exports.Header = exports.Footer = exports.Description = exports.Container = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _SingleStar = _interopRequireDefault(require("@honeybook/icons/dist/icons/SingleStar"));
var _ArrowTour = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowTour"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledIs = _interopRequireDefault(require("../../utils/styled-is"));
var _ArrowLeft = _interopRequireDefault(require("@honeybook/icons/dist/icons/ArrowLeft16"));
var _HBButton = _interopRequireDefault(require("../HBButton/HBButton"));
var _HBProTip = require("../HBProTip/HBProTip");
var _HBText = _interopRequireDefault(require("../HBText/HBText"));
var _animations = require("../../styles/animations");
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11;
var Container = exports.Container = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__Container",
  componentId: "sc-18d7e10-0"
})(["background-color:", ";width:343px;border-radius:2px;display:flex;flex-direction:column;position:relative;", " ", ""], _colors["default"].white, (0, _styledIs["default"])('horizontalOffset')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n        margin-left: ", "px;\n    "])), function (props) {
  return props.horizontalOffset;
}), (0, _styledIs["default"])('verticalOffset')(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n        margin-top: ", "px;\n    "])), function (props) {
  return props.verticalOffset;
}));
var TourActionsContainer = exports.TourActionsContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__TourActionsContainer",
  componentId: "sc-18d7e10-1"
})(["position:relative;height:50px;border-bottom:1px solid ", ";"], _colors["default"].neutral200);
var InnerContainer = exports.InnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__InnerContainer",
  componentId: "sc-18d7e10-2"
})(["display:flex;flex-direction:column;padding:20px;"]);
var InnerLastStepContainer = exports.InnerLastStepContainer = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__InnerLastStepContainer",
  componentId: "sc-18d7e10-3"
})(["display:flex;flex-direction:column;padding:50px 20px 20px 20px;"]);
var StyledArrowIcon = exports.StyledArrowIcon = (0, _styledComponents["default"])(_ArrowLeft["default"]).withConfig({
  displayName: "HBTourTooltipstyles__StyledArrowIcon",
  componentId: "sc-18d7e10-4"
})(["cursor:pointer;position:absolute;left:18px;top:18px;"]);
var StyledCloseIcon = exports.StyledCloseIcon = (0, _styledComponents["default"])(_HBProTip.CloseIcon).withConfig({
  displayName: "HBTourTooltipstyles__StyledCloseIcon",
  componentId: "sc-18d7e10-5"
})(["cursor:pointer;position:absolute;right:18px;top:18px;"]);
var Header = exports.Header = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__Header",
  componentId: "sc-18d7e10-6"
})(["display:flex;align-items:center;margin-bottom:2px;"]);
var StyledGIF = exports.StyledGIF = _styledComponents["default"].img.withConfig({
  displayName: "HBTourTooltipstyles__StyledGIF",
  componentId: "sc-18d7e10-7"
})(["margin-bottom:20px;"]);
var Title = exports.Title = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBTourTooltipstyles__Title",
  componentId: "sc-18d7e10-8"
})(["margin-left:10px;margin-top:-4px;"]);
var Description = exports.Description = (0, _styledComponents["default"])(_HBText["default"]).withConfig({
  displayName: "HBTourTooltipstyles__Description",
  componentId: "sc-18d7e10-9"
})(["white-space:pre-line;"]);
var Footer = exports.Footer = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__Footer",
  componentId: "sc-18d7e10-10"
})(["margin-top:20px;display:flex;justify-content:space-between;align-items:center;flex-direction:row-reverse;"]);
var StepCounter = exports.StepCounter = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__StepCounter",
  componentId: "sc-18d7e10-11"
})(["color:", ";font-size:14px;"], _colors["default"].neutral600);
var NextButton = exports.NextButton = (0, _styledComponents["default"])(_HBButton["default"]).withConfig({
  displayName: "HBTourTooltipstyles__NextButton",
  componentId: "sc-18d7e10-12"
})(["border-radius:2px;display:flex;justify-content:center;align-items:center;color:", ";height:auto;padding:10px 17px;box-shadow:0px 2px 5px 0px rgba(0,18,71,0.2);"], _colors["default"].white);
var StyledLink = exports.StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "HBTourTooltipstyles__StyledLink",
  componentId: "sc-18d7e10-13"
})(["color:inherit;text-decoration:underline;&:hover{color:inherit;}"]);
var TourPixel = exports.TourPixel = _styledComponents["default"].div.withConfig({
  displayName: "HBTourTooltipstyles__TourPixel",
  componentId: "sc-18d7e10-14"
})(["width:1px;height:1px;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);", ""], (0, _styledIs["default"])('overrideStyle')(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n        ", ";\n    "])), function (props) {
  return props.overrideStyle;
}));
var TwinkleStar = exports.TwinkleStar = (0, _styledComponents["default"])(_SingleStar["default"]).withConfig({
  displayName: "HBTourTooltipstyles__TwinkleStar",
  componentId: "sc-18d7e10-15"
})(["position:absolute;z-index:1;animation:", ";animation-iteration-count:infinite;", " ", " ", " ", " ", " ", ""], _animations.twinkle, (0, _styledIs["default"])('top')(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n        top: ", "px;\n    "])), function (props) {
  return props.top;
}), (0, _styledIs["default"])('bottom')(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n        bottom: ", "px;\n    "])), function (props) {
  return props.bottom;
}), (0, _styledIs["default"])('right')(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n        right: ", "px;\n    "])), function (props) {
  return props.right;
}), (0, _styledIs["default"])('left')(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n        left: ", "px;\n    "])), function (props) {
  return props.left;
}), (0, _styledIs["default"])('delay')(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n        animation-delay: ", "ms;\n    "])), function (props) {
  return props.delay;
}), (0, _styledIs["default"])('duration')(_templateObject9 || (_templateObject9 = (0, _taggedTemplateLiteral2["default"])(["\n        animation-duration: ", "ms;\n    "])), function (props) {
  return props.duration;
}));
var StyledArrowTour = exports.StyledArrowTour = (0, _styledComponents["default"])(_ArrowTour["default"]).withConfig({
  displayName: "HBTourTooltipstyles__StyledArrowTour",
  componentId: "sc-18d7e10-16"
})(["position:absolute;z-index:1;", " ", " ", " ", ""], (0, _styledIs["default"])('top')(_templateObject0 || (_templateObject0 = (0, _taggedTemplateLiteral2["default"])(["\n        top: ", "px;\n    "])), function (props) {
  return props.top;
}), (0, _styledIs["default"])('bottom')(_templateObject1 || (_templateObject1 = (0, _taggedTemplateLiteral2["default"])(["\n        bottom: ", "px;\n    "])), function (props) {
  return props.bottom;
}), (0, _styledIs["default"])('right')(_templateObject10 || (_templateObject10 = (0, _taggedTemplateLiteral2["default"])(["\n        right: ", "px;\n    "])), function (props) {
  return props.right;
}), (0, _styledIs["default"])('left')(_templateObject11 || (_templateObject11 = (0, _taggedTemplateLiteral2["default"])(["\n        left: ", "px;\n    "])), function (props) {
  return props.left;
}));
//# sourceMappingURL=HBTourTooltip.styles.js.map